var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"24","height":"24","rx":"5","fill":"white"}}),_c('path',{attrs:{"d":"M9.27752 15.2659L5.37854 11.3993L4 12.7663L9.27752 18L20 7.36704L18.6215 6.00001L9.27752 15.2659Z","fill":"#09B78A"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }